import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router"
import { ThemeProvider } from "./theme/ThemeProvider.js"
import { AuthProvider } from "./auth/AuthProvider.js"
import { ToastProvider } from "./components/ui/Toast.js"
import { AppRoutes } from "./App.js"
import "./styles/global.css"

const rootEl = document.getElementById("root")
if (!rootEl) throw new Error("#root element not found")

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
)
